







import { Mall } from 'ncp-api-supporter';
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { hyundaiMallNos, kiaMallNos } from '@/const/mall';

@Component
export default class Logo extends Vue {
  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  private getLogoUrl() {
    if (this.malls.some(({ mallNo }) => hyundaiMallNos.includes(mallNo))) {
      return require('@/assets/img/hyundai_logo_gnb.png');
    }

    if (this.malls.some(({ mallNo }) => kiaMallNos.includes(mallNo))) {
      return require('@/assets/img/kia_logo_gnb.png');
    }

    return require('@/assets/img/logo_gnb.png');
  }
}
